const Users = {
	
	name: 'Users',
	model: {

		idProperty: 'users__id',
		displayProperty: 'users__username',
		
		properties: [
			{ name: 'users__id',	mapping: 'id',	type: 'int', },
			{ name: 'users__username',	mapping: 'username', },
			{ name: 'users__email',	mapping: 'email', },
			{ name: 'users__email_token',	mapping: 'email_token', },
			{ name: 'users__email_verified',	mapping: 'email_verified',	type: 'bool', },
			{ name: 'users__email_token_expires',	mapping: 'email_token_expires',	type: 'datetime', },
			{ name: 'users__password',	mapping: 'password', },
			{ name: 'users__active',	mapping: 'active',	type: 'bool', },
			{ name: 'users__token',	mapping: 'token', },
			{ name: 'users__token_generated',	mapping: 'token_generated',	type: 'datetime', },
			{ name: 'users__expo_token',	mapping: 'expo_token', },
			{ name: 'users__login_count',	mapping: 'login_count',	type: 'int', },
			{ name: 'users__last_login',	mapping: 'last_login',	type: 'datetime', },
			// { name: 'users__password_reset',	mapping: 'password_reset', },
			// { name: 'users__password_reset_expires',	mapping: 'password_reset_expires',	type: 'datetime', },
		],

	},

	isDynamic: true,
	repository: {
		type: 'onebuild',
	},

};

export default Users;
